export abstract class FeatureFlagIdentificationService {
  abstract identify(userId: string, userProperties: Record<string, string>): void;
  abstract reset(): void;
}
